<main>
  <nav>
    <div class="nav-tab" id="nav-tab" role="tablist">
      <ul 
        ngbNav 
        #nav="ngbNav" 
        [activeId]="activeTab" 
        class="nav-tabs nav-pills" >
        
        <!-- Energie Tab -->
        <li class="nav-item" [ngbNavItem]="'energy'" domId="tab_energy">
          <a class="nav-link me-2 ps-2" ngbNavLink>
            <app-svg source="icons/feather/pie-chart" height="18"></app-svg>
            <span i18n="@@EnergyTab">Energie</span>
          </a>
          <ng-template ngbNavContent><app-energy-monitor></app-energy-monitor></ng-template>
        </li>

        <!-- Bidi Tab -->
        <li class="nav-item" [ngbNavItem]="'bidi'" domId="tab_bidi" *ngIf="this.hasBidi">
          <a class="nav-link me-2 ps-2" ngbNavLink>
            <app-svg source="icons/feather/charging-station" height="18"></app-svg>
            <span i18n="@@BidiTab">Bidi</span>
          </a>
          <ng-template ngbNavContent><app-bidi-charging></app-bidi-charging></ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav"></div>
    </div>
  </nav>

  
</main>
